/* ============================================================
   Taalkiezer in de topbalk: eigen dropdown (DEED, 06-09-2026)
   De native <select name="language_code"> van het thema (localization-form)
   blijft in de DOM maar wordt visueel verborgen; daaroverheen komt een
   knop + paneel in de stijl van het thema. Het paneel opent naar beneden
   en begint onder de gekozen taal. Kiezen zet de waarde op de select en
   vuurt 'change', zodat het thema (localization-form-component) zelf het
   formulier verstuurt. Styling: deed-custom.css, blok 6.
   ============================================================ */
(function () {
  var CHEVRON = '<svg class="deed-lang__chevron" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var CHECK = '<svg class="deed-lang__check" width="12" height="10" viewBox="0 0 12 10" fill="none" aria-hidden="true"><path d="M1 6.15652C1 6.15652 2.03125 6.15652 3.40625 8.56277C3.40625 8.56277 7.22793 2.26069 10.625 1.00027" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function enhance(select) {
    if (select.dataset.deedEnhanced) return;
    select.dataset.deedEnhanced = '1';
    var holder = select.closest('.language-selector') || select.parentElement;
    var form = select.closest('form');
    holder.classList.add('deed-lang');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'deed-lang__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-label', select.getAttribute('aria-label') || 'Language');

    var panel = document.createElement('div');
    panel.className = 'deed-lang__panel';
    panel.setAttribute('role', 'listbox');

    var selectedText = '';
    Array.prototype.forEach.call(select.options, function (opt) {
      var label = opt.textContent.trim();
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'deed-lang__option';
      item.setAttribute('role', 'option');
      item.dataset.value = opt.value;
      item.innerHTML = '<span>' + label + '</span>' + CHECK;
      if (opt.selected) {
        item.classList.add('is-active');
        item.setAttribute('aria-selected', 'true');
        selectedText = label;
      }
      panel.appendChild(item);
    });
    trigger.innerHTML = '<span class="deed-lang__value">' + selectedText + '</span>' + CHEVRON;

    function open() {
      holder.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      holder.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      holder.classList.contains('is-open') ? close() : open();
    });

    panel.addEventListener('click', function (e) {
      var item = e.target.closest('.deed-lang__option');
      if (!item) return;
      e.preventDefault();
      var value = item.dataset.value;
      close();
      if (value === select.value) return;
      trigger.querySelector('.deed-lang__value').textContent = item.textContent.trim();
      holder.classList.add('is-busy');
      select.value = value;
      // Het thema luistert op 'change' en verstuurt dan zelf het formulier
      select.dispatchEvent(new Event('change', { bubbles: true }));
      // Vangnet: als het thema niets doet, zelf versturen
      setTimeout(function () {
        if (form && !form.dataset.deedSubmitted) {
          form.dataset.deedSubmitted = '1';
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        }
      }, 1000);
    });

    if (form) {
      form.addEventListener('submit', function () {
        form.dataset.deedSubmitted = '1';
      });
    }

    document.addEventListener('click', function (e) {
      if (!holder.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    holder.appendChild(trigger);
    holder.appendChild(panel);
  }

  function init() {
    document.querySelectorAll('select[name="language_code"]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
